var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.835 16.6731L16.6731 14.835L19.4175 17.5922L22.1618 14.835L24 16.6731L21.2427 19.4175L24 22.1618L22.1618 24L19.4175 21.2427L16.6731 24L14.835 22.1618L17.5922 19.4175L14.835 16.6731ZM2.589 0H20.712C22.1489 0 23.301 1.1521 23.301 2.589V12.6861C22.5113 12.233 21.644 11.9094 20.712 11.754V2.589H2.589V20.712H11.754C11.9094 21.644 12.233 22.5113 12.6861 23.301H2.589C1.1521 23.301 0 22.1489 0 20.712V2.589C0 1.1521 1.1521 0 2.589 0ZM5.17799 5.17799H18.123V7.76699H5.17799V5.17799ZM5.17799 10.356H18.123V11.754C17.0227 11.9353 16.0129 12.3495 15.1197 12.945H5.17799V10.356ZM5.17799 15.534H11.6505V18.123H5.17799V15.534Z",
    fill: "#607D8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6731 14.835L14.835 16.6731L17.5922 19.4175L14.835 22.1618L16.6731 24L19.4175 21.2427L22.1618 24L24 22.1618L21.2427 19.4175L24 16.6731L22.1618 14.835L19.4175 17.5922L16.6731 14.835Z",
    fill: "#C62828"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelReceipt);
export default __webpack_public_path__ + "static/media/cancel_receipt.33237977.svg";
export { ForwardRef as ReactComponent };